import React, { useState } from 'react'
import { TouchableOpacity, Text, Linking, View, ScrollView } from 'react-native'
import HeaderTabs from '../../components/HeaderTabs'
import { LinearGradient } from 'expo-linear-gradient'
import AsyncStorage from "@react-native-async-storage/async-storage";
import styles from './styles'
import { useEffect } from 'react';
const LevelUpdate = () => {
  const emailPJ = 'verificacao.pj@gpxtecinvest.com.br'
  const emailPF = 'verificacao.pf@gpxtecinvest.com.br'
  const [userType, setUserType] = useState('')
  const [email, setEmail] = useState('')

  useEffect(() => {
    async function getUserType() {
      const user = await AsyncStorage.getItem("usertype");
      setUserType(user)
      setEmail(userType == 'PJ' ? emailPJ : emailPF)
    }
    getUserType()
  }, [])
  return (<>
    <HeaderTabs
      title={"MINHA QUALIFICAÇÃO"}
      iconLeft={"keyboard-arrow-left"}
      subtitle={"Saiba como garantir mais vantagens"}
    />
    <ScrollView>
      <View style={styles.text}>
        {userType == 'PJ' ?
          <>
            <Text style={styles.bold}>PESSOA JURÍDICA</Text>
            <Text>Para atingir o Nível II envie a documentação abaixo para nossa análise:</Text>
            <Text style={styles.list}>
              • Comprovante de endereço atualizado {'\n'}
              • Documento de identificação colorido do sócio administrador com foto, como: RG, CNH ,RNE e PASSAPORTE{'\n'}
              • Selfie do sócio administrador
            </Text>
            <Text style={styles.bold}>
              Para atingir o Nível III envie a documentação solicitado no Nível II juntamente com estas:{'\n'}
            </Text>
            <Text>1.Quando for LTDA:</Text>
            <Text style={styles.list}>
              • Contrato Social{'\n'}
              • Última Alteração Contratual Consolidada{'\n'}
              • Cartão CNPJ
            </Text>
            <Text>2. Quando for S/A ou Cooperativa :</Text>
            <Text style={styles.list}>
              • Estatuto Social, Última Ata Registrada e Ata de eleição Vigente de Diretoria
            </Text>
            <Text style={styles.bold}>Documentos abaixo para ambos os tipos de empresa:</Text>
            <Text style={styles.list}>
              • Faturamento gerencial dos últimos 24 meses (assinado pelo contador){'\n'}
              • Balanços dos 02 (dois) últimos anos e balancete recente (defasagem máxima de 90 dias) (caso apure){'\n'}
              • Dados Bancários: Nome do Banco, agência e conta{'\n'}
              • Documentos dos sócios / avalistas obrigatórios: certidão de casamento ou averbação de divórcio, caso não sejam solteiros; documentos pessoais (RG, CPF CNH ou passaporte vigente){'\n'}
              • Dados bancários: Nome Banco, agência e conta corrente{'\n'}
              • Comprovante de residência dos últimos 60 dias (água, luz ou telefone fixo){'\n'}
              • Contato do responsável pelas operações: Nome, setor, e-mail e telefone{'\n'}
              • Breve descrição das atividades
            </Text>
            <Text style={styles.bold}>Dados do trade responsável:</Text>
            <Text style={styles.list}>
              • Documentos: certidão de casamento ou averbação de divórcio, caso não sejam solteiros; documentos pessoais (RG, CPF, CNH ou passaporte vigente);{'\n'}
              • Carta de autorização para que o mesmo seja o trade da empresa com assinatura dos sócios Administrador dando poderes ao mesmo.{'\n'}
              • Um descritivo de valores a serem transacionados na plataforma.{'\n'}
            </Text>
          </>
          :
          <>
            <Text style={styles.bold}>PESSOA FÍSICA</Text>
            <Text>Para atingir o Nível II envie a documentação abaixo para nossa análise:</Text>
            <Text style={styles.list}>
              • Comprovante de endereço atualizado{'\n'}
              • Documento de identificação colorido com foto, como: RG, CNH ,RNE e PASSAPORTE{'\n'}
              • Selfie.
            </Text>
            <Text style={styles.bold}>Para atingir o Nível III envie a documentação solicitado no Nível II juntamente com estas:</Text>
            <Text style={styles.list}>• Comprovação de capacidade financeira, como: comprovante de renda, salarial, patrimônio, declaração de imposto de renda ou DECORE (Declaração Comprobatória de Percepção de Rendimentos)
            </Text>
          </>
        }
        <View style={styles.contentBtn}>
          <TouchableOpacity onPress={() => Linking.openURL(`mailto:${email}`)} title={email}>
            <LinearGradient
              start={{ x: -1, y: 0 }}
              end={{ x: 1, y: 0 }}
              colors={["#16195B", "#1FBFB5"]}
              style={styles.btn}
            >
              <Text style={styles.textBtn}>IR PARA SEU E-MAIL</Text>
            </LinearGradient>
          </TouchableOpacity>
        </View>
      </View>

    </ScrollView>
  </>

  )
}
export default LevelUpdate